import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateCallRailIntegration as CreateCallRailIntegrationMutation,
    CreateCallRailIntegrationVariables,
    CallRailIntegrationCreateInput,
} from 'nutshell-graphql-types';

import CREATE_CALL_RAIL_INTEGRATION from '../mutations/create-callrail-integration.graphql';

export const useCreateCallRailIntegration = (): {
    createCallRailIntegration: (arg1: CallRailIntegrationCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createCallRailIntegration, {loading, error}] = useMutation<
        CreateCallRailIntegrationMutation,
        CreateCallRailIntegrationVariables
    >(CREATE_CALL_RAIL_INTEGRATION);

    return {
        createCallRailIntegration: (input: CallRailIntegrationCreateInput) =>
            createCallRailIntegration({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
